import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[piqetAngularDraggable]',
})
export class DraggableDirective {
  private isDragging = false;
  private initialX!: number;
  private initialY!: number;
  private xOffset = 0;
  private yOffset = 0;

  constructor(private el: ElementRef) {
    this.el.nativeElement.style.position = 'absolute';
  }
  ngOnInit() {
    // Remove the first modal-content class in the parent hierarchy
    let parent = this.el.nativeElement.parentElement;
    while (parent) {
      if (parent.classList.contains('modal-content')) {
        parent.classList.remove('modal-content');
        break;
      }
      parent = parent.parentElement;
    }
  }
  @HostListener('mousedown', ['$event'])
  onMouseDown(event: MouseEvent) {
    if ((event.target as HTMLElement).closest('.modal-header')) {
      this.isDragging = true;
      this.initialX = event.clientX - this.xOffset;
      this.initialY = event.clientY - this.yOffset;
      document.body.style.cursor = 'move';
    }
  }

  @HostListener('document:mouseup')
  onMouseUp() {
    this.isDragging = false;
    document.body.style.cursor = 'auto';
  }

  @HostListener('document:mousemove', ['$event'])
  onMouseMove(event: MouseEvent) {
    if (this.isDragging) {
      event.preventDefault();

      const mouseX = event.clientX - this.initialX;
      const mouseY = event.clientY - this.initialY;

      this.xOffset = mouseX;
      this.yOffset = mouseY;

      this.el.nativeElement.style.transform = `translate3d(${mouseX}px, ${mouseY}px, 0)`;
      // this.el.nativeElement.style.cursor = 'move';
    }
  }
}
